import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import _defineProperty from '@babel/runtime/helpers/defineProperty';
import cookies from '../cookies/index.js';
import uuid4 from '../uuid4/index.js';
import { getLocalCookieDomain } from '../XDomainCookies/default-domains.js';
import XDomainCookieManager from '../XDomainCookieManager/index.js';
import { decode, encode } from '../hashing/index.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
// ensures multiple async calls return the same value when cookie does not exist initially

var legacyIdSeed = parseInt(Math.random() * 10000000000, 10);
var id = uuid4();

var unhash = function unhash(val) {
  if (val.indexOf('.') !== 0) {
    // This may be a V1, unhashed id
    // TODO: instrument this
    var m = /[0-9A-Za-z]+/.exec(val);

    if (m !== null && m[0] === val) {
      return parseInt(val, 36);
    } else {
      // this is not a valid id
      return false;
    }
  }

  var salt = val.substr(1, 2);
  var strId = val.substr(3);
  return decode(strId, {
    salt: salt
  });
};

var hash = function hash(val) {
  var salt = parseInt(Math.random() * 25 + 10, 10).toString(36) + parseInt(Math.random() * 25 + 10, 10).toString(36);
  return ".".concat(salt).concat(encode(val, {
    salt: salt,
    length: 0
  }));
};

var parseFromCookieValue = function parseFromCookieValue(cookieValue) {
  var _decodeURIComponent$s = decodeURIComponent(cookieValue).split('&').map(function (part) {
    return part.split('=');
  }).reduce(function (obj, _ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];

    return _objectSpread(_objectSpread({}, obj), {}, _defineProperty({}, key, value));
  }, {}),
      legacyIdentifier = _decodeURIComponent$s.u,
      identifier = _decodeURIComponent$s.uuid;

  return {
    legacyIdentifier: unhash(legacyIdentifier || ''),
    identifier: identifier
  };
};

var getUserId = function getUserId(_ref3) {
  var env = _ref3.env,
      _ref3$legacy = _ref3.legacy,
      legacy = _ref3$legacy === void 0 ? true : _ref3$legacy;
  var cookieManager = new XDomainCookieManager({
    namespace: 'bf-xdomain-tracking',
    cookieName: 'bf_visit',
    daysExpiry: 10000,
    env: env
  });
  return cookieManager.get().then(function (value) {
    var _parseFromCookieValue = parseFromCookieValue(value),
        legacyIdentifier = _parseFromCookieValue.legacyIdentifier,
        identifier = _parseFromCookieValue.identifier;

    var hashedId = hash(legacyIdSeed);

    if (legacy) {
      if (!legacyIdentifier) {
        cookieManager.set(encodeURIComponent("u=".concat(hashedId, "&uuid=").concat(identifier || id, "&v=2")));
        return legacyIdSeed;
      }

      return legacyIdentifier;
    } // If a new identifier exists it means it was created by the code below, so we'll return it
    // If the new identifier does not exist, we'll try to return the legacy identifier.


    if (identifier || legacyIdentifier) {
      return identifier || String(legacyIdentifier);
    } // This means we don't have any identifier available, so we'll create both, but use the new one.


    cookieManager.set(encodeURIComponent("u=".concat(hashedId, "&uuid=").concat(id, "&v=2")));
    return id;
  });
};
/**
 *
 * @TODO This method should replace getUserId once we move all services off of depending on third
 * party user tracking (XDomainCookies).
 * @returns {String} UUID
 */

var getUserUUID = function getUserUUID() {
  var _ref4 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref4$legacy = _ref4.legacy,
      legacy = _ref4$legacy === void 0 ? false : _ref4$legacy;

  var cookieConfig = {
    name: 'bf_visit',
    days: 10000,
    domain: getLocalCookieDomain()
  };
  var cookieValue = cookies.get(cookieConfig.name);

  var _parseFromCookieValue2 = parseFromCookieValue(cookieValue),
      legacyIdentifier = _parseFromCookieValue2.legacyIdentifier,
      identifier = _parseFromCookieValue2.identifier;

  var hashedId = hash(legacyIdSeed);

  if (legacy) {
    if (!legacyIdentifier) {
      cookies.set(_objectSpread(_objectSpread({}, cookieConfig), {}, {
        value: encodeURIComponent("u=".concat(hashedId, "&uuid=").concat(identifier || id, "&v=2"))
      }));
      return legacyIdSeed;
    }

    return legacyIdentifier;
  } // If a new identifier exists it means it was created by the code below, so we'll return it
  // If the new identifier does not exist, we'll try to return the legacy identifier.


  if (identifier || legacyIdentifier) {
    return identifier || String(legacyIdentifier);
  } // This means we don't have any identifier available, so we'll create both, but use the new one.


  cookies.set(_objectSpread(_objectSpread({}, cookieConfig), {}, {
    value: encodeURIComponent("u=".concat(hashedId, "&uuid=").concat(id, "&v=2"))
  }));
  return id;
};
var index = {
  getUserId: getUserId,
  getUserUUID: getUserUUID
};

export default index;
export { getUserId, getUserUUID };
